var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgVisa = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 46,
  height: 32,
  fill: "none",
  viewBox: "0 0 46 32",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M.5 4A3.5 3.5 0 0 1 4 .5h38A3.5 3.5 0 0 1 45.5 4v24a3.5 3.5 0 0 1-3.5 3.5H4A3.5 3.5 0 0 1 .5 28z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#172B85",
  fillRule: "evenodd",
  d: "M14.334 21.144h-2.746l-2.06-8.087c-.097-.373-.305-.702-.61-.857a8.8 8.8 0 0 0-2.518-.855v-.312h4.425c.61 0 1.068.468 1.144 1.011l1.069 5.834 2.745-6.845h2.67zm5.645 0h-2.593l2.135-10.11h2.594zm5.492-7.31c.076-.544.534-.856 1.068-.856a4.7 4.7 0 0 1 2.517.467l.459-2.177a6.4 6.4 0 0 0-2.365-.468c-2.518 0-4.35 1.4-4.35 3.344 0 1.479 1.298 2.255 2.214 2.723.99.467 1.373.778 1.296 1.244 0 .7-.763 1.011-1.525 1.011-.916 0-1.832-.233-2.67-.622l-.458 2.178c.916.388 1.907.544 2.823.544 2.822.077 4.576-1.322 4.576-3.422 0-2.645-3.585-2.8-3.585-3.966m12.663 7.31-2.06-10.11h-2.212a1.15 1.15 0 0 0-1.068.777l-3.814 9.333h2.67l.533-1.477h3.28l.306 1.477zm-3.89-7.388.762 3.81H32.87z",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgVisa);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/visa.f5eaaa0265377953cef958f61879d720.svg";